import Popover from "@material-ui/core/Popover";
import { ReactComponent as Run } from "assets/icons/Blue-check.svg";
import { ReactComponent as Download } from "assets/icons/Download.svg";
import { ReactComponent as Duplicate } from "assets/icons/Duplicate-report.svg";
import { ReactComponent as EditReport } from "assets/icons/EditReport.svg";
import { ReactComponent as Print } from "assets/icons/Print.svg";
import { ReactComponent as Share } from "assets/icons/Share.svg";
import { ReactComponent as Delete } from "assets/icons/Trush.svg";
import React from "react";
import styled from "styled-components";
import ActionSvgComponent from "../assets/icons/svg/actionSvg";
import "./style.scss";

import { Route, useHistory, useLocation, useParams } from "react-router-dom";

const Box = styled.div`
  width: 363px;
  height: 49px;
  display: flex;
  > :nth-child(1) {
    width: 100%;
    text-align: start;
    padding-left: 24px;
  }
`;
export default function PenddingPopover({
  style,
  id: batch_id,
  Undeposit,
  generatePdf,
  deleteFilter,
  item,
  setDuolicatetModal,
  setDuolicatetData,
  generateExcelReport,
  handleDownloadPdf,
  toggle,
  handleRunReport,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleOnClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const { push } = useHistory();

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <ActionSvgComponent
        height={style ? style.height : 14}
        width={style ? style.width : 14}
        onClick={handleOnClick}
        color={style && style.color}
      />

      <div>
        {" "}
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {toggle == "Financial Reports" ? (
            <Box className="action-pop-over report-action-pop-over " >
              <div
                className="finance-pop-over"
                onClick={() => {
                  handleRunReport();
                  setAnchorEl(null);
                }}
              >
                <Run
                  style={{
                    marginRight: "13.5px",
                  }}
                />
                <span style={{ color: "#2555EF" }}>
                  Run Report
                </span>
              </div>
            </Box>
          ) : (
            <>
              <Box className="action-pop-over report-action-pop-over ">
                <div
                  className="finance-pop-over"
                  onClick={() => {
                    push({
                      pathname: `/create-new-report/${item._id}`,
                      state: { isRunSegment: true },
                    });
                    localStorage.setItem("goto", "results");
                  }}
                >
                  <Run
                    style={{
                      marginRight: "13.5px",
                      width: "25px",
                    }}
                  />
                  <span style={{ color: "#2555EF" }}>
                    Run Segment
                  </span>
                </div>
              </Box>
              <Box className="action-pop-over report-action-pop-over ">
                <div
                  className="finance-pop-over"
                  onClick={() => {
                    push({
                      pathname: `/create-new-report/${item._id}`,
                    });
                  }}
                >
                  <EditReport
                    style={{
                      marginRight: "13.5px",
                    }}
                  />
                  <span style={{ color: "#2555EF" }}>
                    Edit Segment
                  </span>
                </div>
              </Box>

              <Box className="action-pop-over report-action-pop-over ">
                <div
                  className="finance-pop-over"
                  style={{ paddingLeft: "30px" }}
                  onClick={() => {
                    setDuolicatetModal(true);
                    handleClose();
                    setDuolicatetData((prev) => {
                      return {
                        ...prev,
                        filterId: item._id,
                      };
                    });
                  }}
                >
                  <Duplicate
                    style={{
                      marginRight: "13.5px",
                    }}
                  />
                  <span style={{ color: "#2555EF" }}>
                    Duplicate
                  </span>
                </div>
              </Box>
              <Box className="action-pop-over report-action-pop-over ">
                <div
                  className="finance-pop-over"
                  onClick={() => generateExcelReport(item._id)}
                >
                  <Download
                    style={{
                      marginRight: "13.5px",
                    }}
                  />

                  <span style={{ color: "#2555EF"}}>
                    Download
                  </span>
                </div>
              </Box>
              {/* <Box className="action-pop-over report-action-pop-over ">
                <div className="finance-pop-over">
                  <Share
                    style={{
                      marginRight: "13.5px",
                    }}
                  />
                  <span style={{ color: "#2555EF", marginLeft: "22px" }}>
                    Share
                  </span>
                </div>
              </Box> */}
              <Box className="action-pop-over report-action-pop-over ">
                <div
                  className="finance-pop-over"
                  onClick={() => handleDownloadPdf(item?._id)}
                >
                  <Print
                    style={{
                      marginRight: "13.5px",
                    }}
                  />
                  <span style={{ color: "#2555EF" }}>
                    Print
                  </span>
                </div>
              </Box>
              <Box className="action-pop-over report-action-pop-over ">
                <div
                  className="finance-pop-over"
                  onClick={() => {
                    deleteFilter(item?._id);
                    handleClose();
                  }}
                >
                  <Delete
                    style={{
                      marginRight: "13.5px",
                    }}
                  />
                  <span style={{ color: "#F1585E"}}>
                    Delete
                  </span>
                </div>
              </Box>
            </>
          )}
        </Popover>
      </div>
    </div>
  );
}
